module.exports = __webpack_public_path__ + "img/del1.aea1b4e7.svg";